module.exports = __webpack_public_path__ + "img/17-duck.032629e7.jpg";